import { useContext } from "react";
import gql from "graphql-tag";
import { intlContext } from "translations/context";
import { NaturalPersonState } from "types/NaturalPerson";
import { apolloClient } from "utils";
import IStepObject from "../../types/IStepObject";
import { IDataCompletionAddressInput } from "../../types/registerArgs";

export default function useStepAddress(): IStepObject<IDataCompletionAddressInput> {
  const { translate } = useContext(intlContext);

  return {
    registerFn: dispatchNaturalPersonEvent,
    stepId: NaturalPersonState.address,
    title: translate("data_completion_address_title")
  };
}

const mutation = gql`
  mutation dispatchNaturalPersonEvent($naturalPersonId: ID, $payload: JSON!) {
    dispatchNaturalPersonEvent(event: { type: submitAddress, naturalPersonId: $naturalPersonId, payload: $payload })
  }
`;

async function dispatchNaturalPersonEvent(naturalPersonId: string, args: IDataCompletionAddressInput): Promise<void> {
  await apolloClient.cache.reset();

  const response = await apolloClient.mutate({
    mutation,
    variables: { naturalPersonId, payload: args },
    fetchPolicy: "no-cache"
  });
  if (response.errors) throw response.errors;
}
